import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import urlTemplate from 'url-template';
import { NO_CONTENT } from '../../controllers/coordination/utils/status-codes';
import { errorIfNotOk, pullResponseTextIfNotOk, stargateFetchRetryOn5xx } from '../fetch-utils';
export var TARGETING_SCHEMA_VERSION = '2';
var inProductMessagesUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
export function getMessages(_x, _x2, _x3, _x4) {
  return _getMessages.apply(this, arguments);
}
function _getMessages() {
  _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cloudId, stargateUrl, product, locale) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", stargateFetchRetryOn5xx("".concat(stargateUrl).concat(inProductMessagesUrlTemplate.expand({
            cloudId: cloudId,
            product: product,
            schema: TARGETING_SCHEMA_VERSION,
            locale: locale
          }))).then(errorIfNotOk).then(function (r) {
            return r.json().then(function (messages) {
              return {
                messages: messages,
                interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
              };
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getMessages.apply(this, arguments);
}
function handleStartStopMessageResponse(response) {
  return response.status === NO_CONTENT;
}
var startMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
var startMessageWithVariationIdUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
export function startMessage(_x5) {
  return _startMessage.apply(this, arguments);
}
function _startMessage() {
  _startMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(startMessageConfig) {
    var requestBody;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          requestBody = {
            cloudId: startMessageConfig.cloudId,
            orgId: startMessageConfig.orgId,
            workspaceId: startMessageConfig.workspaceId
          };
          return _context2.abrupt("return", stargateFetchRetryOn5xx(startMessageConfig.variationId ? "".concat(startMessageConfig.stargateUrl).concat(startMessageWithVariationIdUrlTemplate.expand({
            messageId: startMessageConfig.messageId,
            variationId: startMessageConfig.variationId
          })) : "".concat(startMessageConfig.stargateUrl).concat(startMessageUrlTemplate.expand({
            messageId: startMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _startMessage.apply(this, arguments);
}
var stopMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
export function stopMessage(_x6) {
  return _stopMessage.apply(this, arguments);
}
function _stopMessage() {
  _stopMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(stopMessageConfig) {
    var requestBody;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          requestBody = {
            cloudId: stopMessageConfig.cloudId,
            orgId: stopMessageConfig.orgId,
            workspaceId: stopMessageConfig.workspaceId
          };
          return _context3.abrupt("return", stargateFetchRetryOn5xx("".concat(stopMessageConfig.stargateUrl).concat(stopMessageUrlTemplate.expand({
            messageId: stopMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse));
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _stopMessage.apply(this, arguments);
}
var userResponseUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
export function sendUserResponse(_x7, _x8, _x9, _x10) {
  return _sendUserResponse.apply(this, arguments);
}
function _sendUserResponse() {
  _sendUserResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cloudId, stargateUrl, messageId, payload) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", stargateFetchRetryOn5xx("".concat(stargateUrl).concat(userResponseUrlTemplate.expand({
            cloudId: cloudId,
            messageId: messageId
          })), {
            method: 'post',
            body: JSON.stringify(payload),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(function () {
            return Promise.resolve();
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _sendUserResponse.apply(this, arguments);
}
var markSeenAndFatigueUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
export function markAsSeenAndFatigued(_x11) {
  return _markAsSeenAndFatigued.apply(this, arguments);
}
function _markAsSeenAndFatigued() {
  _markAsSeenAndFatigued = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(seenMessageConfig) {
    var requestBody;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          requestBody = {
            cloudId: seenMessageConfig.cloudId,
            orgId: seenMessageConfig.orgId,
            workspaceId: seenMessageConfig.workspaceId
          };
          return _context5.abrupt("return", stargateFetchRetryOn5xx("".concat(seenMessageConfig.stargateUrl).concat(markSeenAndFatigueUrlTemplate.expand({
            messageId: seenMessageConfig.messageId
          })), {
            method: 'post',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(pullResponseTextIfNotOk).then(function () {
            return Promise.resolve();
          }));
        case 2:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _markAsSeenAndFatigued.apply(this, arguments);
}